import { Grid, Wrapper } from '@farewill/ui'
import { useFormikContext } from 'formik'

import { ProbateLeadAttributes } from 'lib/models/lead'
import { Input, SelectInput } from 'components/form'
import ProbateEstatePeopleTermsAndIdChecks from './probate-estate-people-terms-and-id-checks'
import { FAREWILL_LEGAL_SERVICES } from 'utils/enums'
import SectionHeading from './section-heading'
import SectionStatus from 'components/section-status'
import { scrollToDataId } from 'lib/window/scroll'

const PROBATE_REFERRAL_OPTIONS = [
  { label: 'Dignity Legal Services', value: 'farewill_legal_services' },
  { label: 'New Law', value: 'new_law' },
]

const Referral = ({ isComplete }: { isComplete: boolean }) => {
  const { handleSubmit, setFieldValue, values } =
    useFormikContext<ProbateLeadAttributes>()

  const handleSave = ({
    name,
    value,
  }: {
    name: string
    value: string | null
  }) => {
    setFieldValue(name, value)
    handleSubmit()
  }

  const isQuotesComplete = !!values.quoteAttributes.interestedInEstateAdmin
  const isInHouseReferral =
    values.quoteAttributes.referredTo === FAREWILL_LEGAL_SERVICES

  return (
    <>
      <Grid gap="L" data-testid="referral">
        <SectionHeading
          title="9. Referral"
          scrollId="referral"
          isComplete={isComplete}
        />
        <Grid.Item>
          <Wrapper maxWidth={320} margin={[0, 0, 'S']}>
            <SelectInput
              label="Who are we referring the case to?"
              options={PROBATE_REFERRAL_OPTIONS}
              name="quoteAttributes.referredTo"
              handleSave={({ name, value }) => {
                handleSave({ name, value: value ? value.toString() : null })
              }}
            />
          </Wrapper>
          {values.quoteAttributes.referredTo !== FAREWILL_LEGAL_SERVICES && (
            <Input
              name="quoteAttributes.referralNotes"
              component="textarea"
              handleSave={handleSave}
              label="Handover notes"
              rows={6}
            />
          )}
        </Grid.Item>
      </Grid>
      {isInHouseReferral && (
        <>
          {isQuotesComplete ? (
            <ProbateEstatePeopleTermsAndIdChecks
              isInHouseReferral={isInHouseReferral}
            />
          ) : (
            <Wrapper margin={['L', 0, 0]}>
              <SectionStatus
                complete={false}
                heading="Select a service first"
                incompleteContent={
                  <>
                    Please select Essential Probate or Complete Probate in the{' '}
                    <button
                      type="button"
                      onClick={() => scrollToDataId('quotes')}
                      style={{
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        background: 'none',
                        border: 'none',
                        padding: 0,
                        font: 'inherit',
                        color: 'inherit',
                      }}
                    >
                      Quotes section
                    </button>{' '}
                    below before completing executor checks.
                  </>
                }
              />
            </Wrapper>
          )}
        </>
      )}
    </>
  )
}

export default Referral
